import {ITProcessRelateTypes} from '../../../util/uiconstants';

export default ({itProcessTypeId, itProcessTypeID, itProcessSubTypeId, itProcessSubTypeID}) => {
	const type = itProcessTypeId || itProcessTypeID;
	const subType = itProcessSubTypeId || itProcessSubTypeID;
	return ITProcessRelateTypes?.[type || subType] ?? '-';
};
